import { isInsideScene } from '../scene/insideScenes/registry';
import { sceneEntered } from '../analytics/sceneTracker';
import { stopVirtualTour } from './appState';
import { $assistantMessages } from './assistantHud';
import { $assistantWaitingSceneOpen } from './sceneOpen';
import { $activeScene, enterScene } from './sceneNavigation';
import { saveCurrentSceneSnapshot } from './sceneState';

/**
 * Direct push of an inside-scene onto the stack.
 *
 * Used by chat scene-banner clicks (AssistantHud.handleEnterScene) AND
 * 3D POI markers whose `moveToSceneId` points to an inside-scene. No backend
 * round-trip, no chat side-effects — pure navigation.
 *
 * Saves a snapshot of the current (parent) scene's chat + camera pose so
 * that `goBack` can restore both instantly without replaying the preloader
 * or re-fetching `scene_open`. Snapshot is keyed by parent `poiFilterId`.
 *
 * Conditions for snapshot save (must match what `goBack` restore expects):
 *   - leaving a non-inside (= main) scene;
 *   - chat already has content;
 *   - no `scene_open` POST in flight (otherwise we'd save a half-empty chat).
 *
 * Assistant messages are pre-marked `disableAnimation: true` so the
 * typewriter doesn't replay on return.
 */
export const enterInsideScene = (sceneId: string): void => {
  if (!isInsideScene(sceneId)) {
    console.warn('[enterInsideScene] target is not an inside-scene:', sceneId);
    return;
  }
  const activeScene = $activeScene.getState();
  if (activeScene?.sceneId === sceneId) return;

  const messages = $assistantMessages.getState();
  const waitingSceneOpen = $assistantWaitingSceneOpen.getState();

  if (
    activeScene &&
    !isInsideScene(activeScene.sceneId) &&
    messages.length > 0 &&
    !waitingSceneOpen
  ) {
    const snapshotMessages = messages.map((m) =>
      m.role === 'assistant' && !m.disableAnimation
        ? { ...m, disableAnimation: true }
        : m,
    );
    saveCurrentSceneSnapshot({
      sceneId: activeScene.poiFilterId,
      messages: snapshotMessages,
    });
  }

  stopVirtualTour();
  enterScene({ sceneId, poiFilterId: sceneId });
  sceneEntered(sceneId);
};
